import React, { Component } from "react";
import { Spin, Select } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";
import './Styles.css';

const { Option } = Select;

const isStrictObjectId = (v) => {

    // Caso 2: string 24 hex exactos
    if (typeof v === "string" && /^[0-9a-fA-F]{24}$/.test(v)) {
        return true;
    }

    return false;
};

class SelectHorariosItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: [],
      cargando: false,
      primerCarga: false,
      dropdownOpen: false,
    };

    // debounce mantiene `this`, pero pasamos un wrapper para aceptar 2 params
    this.buscarHorarios = debounce((texto, opts) => this._buscarHorarios(texto, opts), 300);
  }

  componentDidMount() {
    // Comportamiento normal: precargar
    // Con lessCharge: NO precarga; solo cuando enfoque/click (focus/open)
    if (!this.props.lessCharge) {
      this.buscarHorarios("");
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      // Con lessCharge: SOLO buscar si el value es ObjectId (para poder "resolver" el seleccionado)
      if (this.props.lessCharge) {
        if (isStrictObjectId(this.props.value)) {
          // fuerza búsqueda por value (para traer el item aunque no se haya abierto el dropdown)
          this.buscarHorarios("", { force: true, byValue: true });
        }
        return;
      }

      // Comportamiento normal (sin lessCharge)
      if (this.props.value) {
        const buscarHorario = this.state.opciones.find(
          (horario) => horario._id?.toString() === this.props.value?.toString()
        );
        if (!buscarHorario) {
          this.buscarHorarios(this.props.value || '');
        }
      }
    }
  }

  // Se ejecuta solo vía debounce (arriba)
  async _buscarHorarios(texto = "", opts = {}) {
    const { force = false, byValue = false } = opts;

    // ====== REGLA lessCharge ======
    // Solo buscar:
    // - cuando el usuario hace click/focus (dropdownOpen) o
    // - cuando el value sea ObjectId (force/byValue)
    // y SOLO si lessCharge está activa
    if (this.props.lessCharge) {
      const allowByFocus = this.state.dropdownOpen === true;
      const allowByValue = force === true && (byValue ? isStrictObjectId(this.props.value) : true);

      if (!allowByFocus && !allowByValue) return;
    }

    this.setState({ cargando: true });

    try {
      const res = await axios.post(
        "horarios/selectHorariosItem",
        {
          empresaId: this.props.empresaId,
          query: texto,
          values: this.props.value, // si viene ObjectId, el backend puede resolverlo
        },
        { headers: this.props.headersToken }
      );

      if (res.data.success === 2) {
        this.setState({
          opciones: res.data.horarios,
          primerCarga: true,
        });
      } else {
        this.setState({ opciones: [] });
      }
    } catch (error) {
      console.error("Error al buscar horarios:", error);
      this.setState({ opciones: [] });
    } finally {
      this.setState({ cargando: false });
    }
  }

  handleFocus = () => {
    // click/cursor => buscar solo si lessCharge
    if (this.props.lessCharge) {
      // primera vez que se enfoca, trae algo (por ejemplo top 10)
      if (!this.state.primerCarga) this.buscarHorarios("", { force: true });
    }
  };

  handleDropdownVisibleChange = (open) => {
    this.setState({ dropdownOpen: open });

    if (this.props.lessCharge && open) {
      // al abrir dropdown por primera vez, trae lista inicial
      if (!this.state.primerCarga) this.buscarHorarios("", { force: true });
    }
  };

  render() {
    const {
      noBuscar,
      mode,
      disabled,
      fondoBlanco,
      sinBorde,
      width,
      style,
      placeholder,
      lessCharge, // <- importante: se consume aquí (no se manda al <Select />)
      ...restProps
    } = this.props;

    const propsNuevas = {
      showSearch: !noBuscar,
      filterOption: false,
      mode,
      // Con lessCharge, solo permite buscar si el dropdown está abierto (focus/click ya ocurrió)
      onSearch: (txt) => {
        if (lessCharge && !this.state.dropdownOpen) return;
        this.buscarHorarios(txt);
      },
      notFoundContent: this.state.cargando ? (
        <div style={{ textAlign: "center", padding: "8px" }}>
          <div style={{ marginTop: "8px", fontSize: "12px", color: "#999" }}>
            Buscando horarios...
          </div>
        </div>
      ) : this.state.primerCarga ? (
        "No se encontraron horarios"
      ) : null,
      loading: this.state.cargando,
      onFocus: this.handleFocus,
      onDropdownVisibleChange: this.handleDropdownVisibleChange,
    };

    if (mode === "multiple") {
      propsNuevas.maxTagCount = "responsive";
    }

    const estiloFinal = {
      color: disabled ? "black" : "inherit",
      backgroundColor: disabled ? (fondoBlanco ? "white" : "white") : null,
      borderBottom: sinBorde ? "none" : "1px solid #E0FFFFFF",
      borderRadius: "4px",
      transition: "border-color 0.3s ease",
      boxShadow: sinBorde ? "none" : "0 1px 3px rgba(0, 0, 0, 0.1)",
      width: width || undefined,
      opacity: disabled ? 1 : undefined,
      ...style,
    };

    return (
      <Select
        className={`custom-disabled-select ${disabled ? "custom-disabled" : ""}`}
        dropdownMatchSelectWidth={400}
        disabled={disabled}
        dropdownRender={(menu) => <Spin spinning={this.state.cargando}>{menu}</Spin>}
        {...propsNuevas}
        {...restProps}
        onChange={(value) => {
          const horario = this.state.opciones.find((h) => h._id === value);
          this.props.onChange(value, horario);
        }}
        placeholder={this.state.cargando && !this.state.primerCarga ? "Cargando..." : placeholder}
        style={estiloFinal}
        bordered={false}
      >
        {this.state.opciones.map((horario) => (
          <Option key={horario._id} value={horario._id}>
            {horario.stringBuscar}
          </Option>
        ))}
      </Select>
    );
  }
}

export default SelectHorariosItem;